import { render, staticRenderFns } from "./AppFormTitle.vue?vue&type=template&id=241e7065&scoped=true"
import script from "./AppFormTitle.vue?vue&type=script&lang=js"
export * from "./AppFormTitle.vue?vue&type=script&lang=js"
import style0 from "./AppFormTitle.vue?vue&type=style&index=0&id=241e7065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241e7065",
  null
  
)

export default component.exports